export default __webpack_public_path__ + "images/3f0c1f4fd7f0d5b85e79521138d5d964-home_and_garden.jpg";